import platform from '@propertypal/shared/src/utils/platform';
import { Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { LoginSection, LoginWrapper } from '../login/Login.style';
import EstateAgentInfoFormContainer from './EstateAgentInfoFormContainer';
import { Points, PointsHeader, SignUpHeader, TextContainer, Wrapper } from './EstateAgentInformation.style';

const EstateAgentInformation = () => {
  return (
    <Wrapper>
      <LoginWrapper>
        <LoginSection>
          <EstateAgentInfoFormContainer />
          <TextContainer>
            <SignUpHeader>
              FROM CUTTING EDGE FEATURES, TO OUR FRIENDLY AND HELPFUL SUPPORT TEAM, {platform.title.toUpperCase()} MAKES
              MAKES LISTING YOUR PROPERTIES QUICK, EASY AND HASSLE FREE.
            </SignUpHeader>
            <Text color="#353535" style={{ marginBottom: '35px' }}>
              You don&apos;t need to download, install or configure anything (no IT department required!). All you need
              is a web based browser and an internet connection.
            </Text>
            <PointsHeader>OUR CORE SERVICES INCLUDE:</PointsHeader>
            <Points>
              <li>Reach millions of active property searchers every month</li>
              <li>Feature your clients properties for additional exposure</li>
              <li>Increase your volume of leads significantly</li>
              <li>Power your business website with our industry leading Estate Agent Website Services</li>
              <li>Recognised as one of Ireland&apos;s leading digital brands</li>
              <li>
                Cost effective and easy to budget for. Our pricing structure helps control your maximum spend on a
                calendar month.
              </li>
            </Points>
          </TextContainer>
        </LoginSection>
      </LoginWrapper>
    </Wrapper>
  );
};

export default EstateAgentInformation;
